import { css } from '@emotion/css';

import {
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const cardStatsClassName = css({
  alignItems: 'stretch',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: Spacing.LG,
});

export const labelClassName = css({
  fontWeight: FontWeight.SEMI_BOLD,
});

export const valueClassName = css({
  [SMALL_DEVICE_MQ]: {
    fontSize: FontSize.REGULAR,
    fontWeight: FontWeight.MEDIUM,
  },
});
